import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaHome, FaUserPlus, FaArrowLeft } from "react-icons/fa";
import { parseJWT } from "../../utils/jwtUtils";
import { FiHome } from "react-icons/fi";
import { MdArrowBackIosNew } from "react-icons/md";

const Footer = () => {
  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;
  const userInfo = parseJWT(token?.token);
  const navigate = useNavigate();
  const [showFooter, setShowFooter] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        // Scrolling down
        setShowFooter(false);
      } else {
        // Scrolling up
        setShowFooter(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const handleHome = () => {
    navigate("/betamountpage"); // or your home route
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleShareReferral = (refCode) => {
    if (!refCode) {
      alert("Referral code not found!");
      return;
    }

    const signupUrl = `https://zemedbingo.com/signup?ref=${refCode}`;
    const message = `በእርሶ ሪፈራል ኮዶ አንድ ሰው ሲመዘገብ 2 ብር ተከፋይ ይሆናሉ : ${refCode}\nአሁኑኑ ይመዝገቡ : ${signupUrl}`;

    // Open each link directly
    const shareLinks = {
      Telegram: `https://t.me/share/url?url=${encodeURIComponent(
        signupUrl,
      )}&text=${encodeURIComponent(message)}`,
    };

    return shareLinks;
  };

  return (
    <>
      {/* 🔻 Bottom Fixed Navigation */}
      <div
        style={{
          // background: "#0e3e3d",
          //  transition: "transform 0.3s ease-in-out",
          transform: showFooter ? "translateY(0)" : "translateY(100%)",
        }}
        className="block md:hidden fixed bottom-0 left-0 right-0 flex flex-wrap justify-between gap-6 items-center mx-auto px-6 py-2 z-40 bg-gradient-to-l from-violet-950 via-violet-800 to-violet-950"
      >
        {/* Invite */}
        {/* <button
          onClick={() =>
            window.open(handleShareReferral(userInfo?.referralCode).Telegram)
          }
          className="flex flex-col items-center gap-1 hover:text-yellow-400 transition"
        >
          <FaUserPlus size={20} />
        </button> */}
        {/* Home */}
        <button
          onClick={handleHome}
          className="flex flex-col items-center gap-1 hover:text-green-400 transition"
        >
          <FiHome size={20} />
          {/* <span className="text-xs font-serif">Home</span> */}
        </button>
        {/* Back */}
        <button
          onClick={handleBack}
          className="flex flex-col items-center gap-1 hover:text-red-400 transition"
        >
          <MdArrowBackIosNew size={20} />
          {/* <span className="text-xs font-serif">Back</span> */}
        </button>
      </div>
    </>
  );
};

export default Footer;
